import styled from 'styled-components';

export const ThumbWrapper = styled.div`
  height: 12px;
  width: 12px;
  padding: 5px 16px 10px 16px;
  transition: transform 0.2s linear;

  transform: translate(-22px, -12.5px);

  &.isDragged {
    transition: none;
  }

  &.isDisabled:hover {
    cursor: not-allowed !important;
  }

  #thumbDefault circle {
    fill: ${({ theme }) => theme.thumbDefaultFill};
    stroke: ${({ theme }) => theme.thumbDefaultStroke};
    stroke-width: 2px;
    top: 4px;
  }

  #thumbHovered path {
    fill: ${({ theme }) => theme.thumbHoveredFill};
    stroke: ${({ theme }) => theme.thumbHoveredStroke};
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2px;
    fill-rule: evenodd;
  }
`;

export const TrackWrapper = styled.div`
  height: 2px;
  flex: 1;
  padding: 12px 0;
  background-color: transparent;

  &.isDisabled:hover {
    cursor: not-allowed !important;
  }
`;

export const TrackWrapperUnplayed = styled.div`
  height: 2px;
`;

export const ThumbTooltip = styled.div`
  position: absolute;
  top: 30px;
  left: 0;
  background-color: #fff;
  padding: 8px;
  border-radius: 4px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 300;
  color: ${({ theme }) => theme.thumbTooltipColor};
  box-shadow:
    0 3px 6px rgba(0, 0, 0, 0.16),
    0 3px 6px rgba(0, 0, 0, 0.23);
`;
